// 테넌트 ID별 창고 레이아웃 로더
import defaultLayout from './layout_default';

export function getLayout(tenantId) {
  switch (tenantId) {
    // case 'STORAGE_01': return require('./layout_STORAGE_01').default;
    default: return defaultLayout;
  }
}
